export class AddToWinnerData {}
